import hash from 'object-hash';

export default () => (fn) => {
  const cache = {};
  return (...args) => {
    const key = hash(args);
    if (!cache[key]) {
      cache[key] = fn(...args);
    }
    return cache[key];
  }
}


// WEBPACK FOOTER //
// ./src/api/cache-service.js